import Tooltip from "./Tooltip";

import "./styles/style.scss";

export default Tooltip;
